import { ajaxAuth } from "@tm/utils"
import { CompilationArticleInterface } from ".."
import { WebserviceUrl } from "../../webserviceUrls"
import { ArticleAddRequestWM } from "."

export function addArticleWM(articles: CompilationArticleInterface) {
    const url = `${WebserviceUrl.CompilationsArticleCompilationsWm}/ArticlesAdd`
    const body = {
        compilationId: articles.compilationId,
        articles: mapArticleToAddRequest(articles.articles),
    }

    return ajaxAuth({ url, body, method: "POST" })
}

function mapArticleToAddRequest(articles: CompilationArticleInterface["articles"]): ArticleAddRequestWM[] {
    return articles.map((article) => ({
        quantity: article.quantity,
        description: article.description,
        wholesalerArticleNo: article.wholesalerArticleNo,
        note: article.note,
        customerArticleNumber: article.customerArticleNumber,
        supplierArticleNumber: article.supplierArticleNumber,
        supplierId: article.supplierId,
    }))
}
